<style lang="scss" scoped>
	.channelName{
		width: 55%;
		float: left;
		margin-right: 10px;
	}
	.creareform .vview-formitem {
    margin-bottom: 10px;
	line-height: 32px;

}
</style>

<template>
    <div>
        <compWrapper :title="$t('global.common.base_information', { defaultValue: '基本信息' })" theme="primary">
			<compFormQuery v-if="type=='query'" class="margin-top-15 margin-right-15" :formdata="getBase" :value="formData"></compFormQuery>
            <compFormEdit v-else class="margin-top-15 margin-right-15" :formdata="getBase" v-model="formData" ref="baseform" />
		</compWrapper>
		<compWrapper :title="$t('erp.channelbase.interface_info', { defaultValue: '接口信息' })" theme="primary">
			<Alert v-show="formData.type=='amazon' && query==false" class="margin-left-20 margin-right-20 margin-top-15 font-bold" type="error">{{$t('erp.channelbase.change_token_warning', { defaultValue: '若更改Token信息，则此渠道所有的分组下的所有的渠道的Token均会更新，请谨慎操作!' })}}</Alert>
			<compCreateInterface v-if="type=='create'" class="margin-top-15 margin-right-15" :queryType="type" :formType="formData.type" ref="createinterface" @on-timezone="handleSelectTimeZone"></compCreateInterface>
			<compQueryInterface v-else class="margin-top-15 margin-right-15" :queryType="type" :formType="formData.type" :queryformData="queryFormData" :activedtype="activedtype" ref="queryinterface"></compQueryInterface>
		</compWrapper>
		<compWrapper :title="$t('erp.channelbase.order_info', { defaultValue: '订单相关信息' })" theme="info">
			<compFormQuery v-if="type=='query'" class="margin-top-15 margin-right-15" :formdata="getOrder" :value="formData"></compFormQuery>
            <compFormEdit v-else class="margin-top-15 margin-right-15" :formdata="getOrder" v-model="formData" />
		</compWrapper>
        <compWrapper :title="$t('erp.channelbase.shop_info', { defaultValue: '店铺注册信息' })" theme="info">
            <compFormQuery v-if="type == 'query'" class="margin-top-15 margin-right-15" :formdata="getChannelInfo" :value="formData"></compFormQuery>
            <compFormEdit v-else class="margin-top-15 margin-right-15" :formdata="getChannelInfo" v-model="formData" ref="channelInfoForm"></compFormEdit>
        </compWrapper>
		<compWrapper :title="$t('global.common.other_information', { defaultValue: '其他信息' })" theme="info">
			<compFormQuery v-if="type=='query'" class="margin-top-15 margin-right-15" :formdata="getOther" :value="formData"></compFormQuery>
            <compFormEdit v-else class="margin-top-15 margin-right-15" :formdata="getOther" v-model="formData" />
			<div class="text-right padding-right-20" v-show="type!='query'">
                <vButton theme="info" class="margin-right-10" v-if="(formData.type=='amazonvendor' || formData.type=='amazonvendords')&&type=='add'" @click="submit('vendors')">{{$t('erp.channelbase.auth_submit', { defaultValue: "保存并授权" })}}</vButton>
				<vButton theme="primary" @click="submit">{{formData.type=='amazonvendor' || formData.type=='amazonvendords'? $t('global.common.save', { defaultValue: '保存' }):$t('global.modal.confirm', { defaultValue: '确定' })}}</vButton>
				<vButton class="margin-left-10" @click="cancel">{{$t('global.common.operation_cancel', { defaultValue: '取消' })}}</vButton>
			</div>
		</compWrapper>
        <!-- amazon单独显示 -->
        <compWrapper :title="$t('erp.channelbase.contactshop', { defaultValue: '关联店铺' })" theme="warning" v-if="(formData.type=='amazon' ||formData.type=='amazonvendor' || formData.type=='amazonvendords')&&type=='query'">
			<vTable
                class="margin-15"
                :columns="shopcolumns"
                :data="shopdatalist"
                size="small"
                ref="table"
                border
            ></vTable>
		</compWrapper>
		<compWrapper :title="$t('global.common.operate_history', { defaultValue: '操作历史' })" theme="gray" v-if="query">
			<compLog class="margin-15" :data="opLogList"></compLog>
		</compWrapper>
		<vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>

import { mapState, mapGetters,mapMutations } from "vuex";
import { HttpSysOpLog } from '@/service/boss/allot';
import { HttpQueryAccount, HttpSaveAccount, HttpGetAccountInterface, HttpGetTimeZone } from "@/service/managechannel/managechannel";
import { HttpActiveGetService, HttpNewActiveGetService} from '@/service/boss/b2corder'
export default {
	props:['activeids','querytype','activedtype'],
    components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
		compLog: () => import("./log"),
		compQueryInterface: () => import("./queryinterface"),
		compCreateInterface: () => import("./createinterface"),
    },
    data(){
        return {
			type: this.$route.params.type,
            channeltype: this.$route.query.channeltype,
            notify: this.$route.query.notify,
			id:this.$route.query.id,
			query: false,
			formData:{
				// shipType: 0,
				orderOnlyShow:"N",
				isLineRelate:"N",
				saleType:'retailer',
				timeoutDays:3,
				lineRelateId:'0',
				defaultManMadeShipment:'0',
                isAccountPay:'0',
                issueAccountPay:'0',
				isOpenSFP:'0',
				allowUpdate:'0'
			},
			queryFormData:{},
			opLogList: [],
			showtip:"",
			styWidth : 210,
			LogformData:{
				page: 1,
				rows: 10,
				sidx: 'id',
                sord: 'desc',
                "search[EQ_opModel]":'Account',
                "search[EQ_opDataId]":this.$route.query.id || this.activeids,
			},
			countryList:[
				{label:this.$t('erp.channelbase.north_america', { defaultValue: '北美' }),areaCode:'North America'},
				{label:this.$t('erp.channelbase.europe', { defaultValue: '欧洲' }),areaCode:'Northwest Europe'},
				{label:this.$t('erp.channelbase.asia', { defaultValue: '亚洲' }),areaCode:'Asia'},
            ],
			loading:false,
			nowdate:'',
            flagtype:false,
            sysdeliveries:[],
            shopdatalist:[],
            requireChannelInfo: false,
            validKey: ["name", "address", "city", "state", "country", "postcode"],
            timeZoneList: []

        }
    },
    created(){
        this.getTimeZone();
		if(this.activeids){
            this.id = this.activeids
			this.type = this.querytype
        }else{
            this.id = this.id
            this.type = this.type
		}
        if(this.notify){
            if(this.notify == 200){
                this.$Message.success(this.$t('erp.channelbase.notifysuccess', { defaultValue: "授权成功！" }))
            }
            if(this.notify == 400){
                this.$Message.error(this.$t('erp.channelbase.notifyerror', { defaultValue: "授权失败！" }))
            }
        }
        if(this.type == 'create' && this.channeltype){
            this.formData.type = this.channeltype;
            this.flagtype = true;
        }
		this.query = this.type === "query";
		if (this.type == 'query' || this.type == 'edit') {
			this.getDetail()
		}else{
			this.getNowFormatDate()
		}
        // HttpActiveGetService().then(res=>{
        HttpNewActiveGetService({
            customerId: global.SYSID,
        }).then(res => {
            this.sysdeliveries = res.data.map(res=>{
                return {
                    value: res.code,
                    label: `${res.code}(${res.carrierServiceName})`
                }
            })
        },err=>{
            this.$VMessage.error(err.message);
        })
	},
    computed:{
        ...mapState("boss", ["accounts",'products','allaccounties']),
		...mapGetters('common',['getMarketplaceId']),
		...mapGetters('diction',['getNewProductList']),
 		// ...mapMutations('dictionary', ['clearStore']),
        shopcolumns(){
            return [
				{
					title: this.$t('erp.managewarehouse.shop_name',{defaultValue:'店铺名称'}),
					key: 'flag',
				}, {
					title: this.$t('erp.channelbase.country', { defaultValue: "国家" }),
					key:'countryCode'
				},
				{
					title: this.$t('fbb.bill.freeze_createdat',{defaultValue:'创建日期'}),
					key: "createdAt"
				},
                {
					title: this.$t('global.common.status', { defaultValue: '状态' }),
					key: "status"
				},
            ]
        },
		accountsAll(){
            return this.accounts.sort(function(a,b){
                return a.title.localeCompare(b.title)
            })
		},
		productList(){
			return [{
				value:0,
				label:'Others'
			},...this.getNewProductList]
		},
        getBase() {
			// 去掉ebay
			let newAccountTypeList = this.allaccounties.filter(i => {
				return i.name.toLowerCase() !== 'ebay'
			})
			this.showtip = this.type == 'edit' || this.type == 'query'
			this.showtipcreate = this.type == 'edit' || this.type == 'create'
			return [
				{
				label: this.$t('erp.channelbase.channel_type', { defaultValue: "渠道类型" }),
				tag: 'vSelect',
				key: "type",
				query:this.showtip,
				// valueText: '123',
				options:newAccountTypeList.map(function(item){
					// console.log(item)
					return {
						value: item.name.toLowerCase(),
						label: item.name.toLowerCase()+'('+item.note+')'
					}
				}),
				formItem:{
					labelWidth:this.styWidth,
					tip: this.showtip ? '' : `<div class="color-error">${this.$t('erp.channelbase.not_channel_warning', { defaultValue: '添加的渠道不在列表中，可联系客服添加' })}</div>`,
				},
				props:{
					filterable:true,
                    // disabled:this.flagtype,
				},
                show:!this.flagtype,
			},
            {
                label: this.$t('erp.channelbase.channel_type', { defaultValue: "渠道类型" }),
				tag: 'div',
                show:this.flagtype,
                formItem:{
                    labelWidth:this.styWidth,
                },
                children: (h) => {
                    let urls = {
                        wayfair:'/companyicon/wayfair.jpg',
                        amazon:'/companyicon/amazon.png',
                        amazonvendords:'/companyicon/amazonvendords.jpg',
                        overstock:'/companyicon/overstock.jpg',
                        homedepot:'/companyicon/homedepot.jpg',
                        walmart:'/companyicon/walmart.jpg',
                        ebay:'/companyicon/ebay.jpg',
                        shopify:'/companyicon/shopify.png',
                        hayneedle:'/companyicon/hayneedle.jpg',
                        houzz:'/companyicon/houzz.jpg',
                        offline:'/companyicon/offline.jpg',
                        eccang:'/companyicon/eccang.png',
                    }
                        // <span>{this.getImage(this.formData.type)}</span>
                    return <div>
                        <span>{this.getTypeTitle(this.formData.type)}</span>
                        <img src={urls[this.formData.type]} style="width: 60px;height: 30px;vertical-align: bottom;margin-left: 15px;"/>
                    </div>
                },
            },
			{
				label: this.$t('erp.channelbase.channel_code', { defaultValue: "渠道代码" }),
				key: "flag",
				query:this.showtip,
				show:this.showtip,
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			{
				label: this.$t('erp.channelbase.channel_name', { defaultValue: "渠道名称" }),
				key: "title",
				show:this.type=='create',
				props:{
					placeholder: this.$t('erp.channelbase.input_warning', { defaultValue: "只能输入数字、字母、下划线和横杠" }),
				},
				formItem:{
					labelWidth:this.styWidth,
					tip: this.showtip ? '' : `<div class="color-error">${this.$t('erp.channelbase.save_tip', { defaultValue: '保存后会自动生成渠道标志和渠道标题，生成规则为渠道名称-销售国别英文缩写' })}</div>`,
				}
			},
			{
				label: this.$t('erp.channelbase.channel_title', { defaultValue: "渠道标题" }),
				key: "title",
				show:this.showtip,
				props:{
					placeholder: this.$t('erp.channelbase.input_warning', { defaultValue: "只能输入数字、字母、下划线和横杠" }),
				},
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			{
				label: this.$t('erp.channelbase.start_running_time', { defaultValue: "开始运营时间" }),
				tag: 'vDatepicker',
				key: 'beginSalesDate',
				query:this.showtip,
				required:false,
				props:{
					format:'yy-mm-dd',
					confirm:false,
				},
				formItem:{
					labelWidth:this.styWidth,
					tip: this.showtip ? '' : `<div class="color-error">${this.$t('erp.channelbase.interface_tip', { defaultValue: '接口从渠道激活当天获取订单，部分渠道支持从开始运营时间自动获取订单（仅amazon和shopify)；若开始运营时间为过去，补取之前的订单需联系客服' })}</div>`,
				}
            },
            {
				label: this.$t('global.common.notes', { defaultValue: "备注" }),
				key: "remark",
				tag:'vTextarea',
				required:false,
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			{
				label: this.$t('erp.channelbase.is_main_account', { defaultValue: "是否为主账号" }),
				tag:'div',
				show:this.query,
				valueText:this.formData.parentAccountFlag==''?this.$t('erp.global.yes', { defaultValue: '是' }):this.$t('erp.global.no', { defaultValue: '否' }),
				formItem:{
					labelWidth:this.styWidth,
				}
			}
			];
		},
		getOrder(){
			const _this = this
			return [
			// query1
			// {
			// 	label: this.$t('erp.channelbase.sale_type', { defaultValue: "销售方式" }),
			// 	tag: 'div',
			// 	required: false,
			// 	show:this.query,
			// 	valueText:this.formData.saleType=='retailer'?this.$t('erp.b2c.ordertype_normally', { defaultValue: '正常销售' }): this.$t('erp.channelbase.part_sale_channel', { defaultValue: '分销渠道' }),
			// 	formItem:{
			// 		labelWidth:this.styWidth,
			// 	}
			// },
			// {
			// 	label: this.$t('erp.channelbase.sale_type', { defaultValue: "销售方式" }),
			// 	key: "saleType",
			// 	tag: 'vSelect',
			// 	required: false,
			// 	show:!this.query,
			// 	options: [
			// 		{
			// 			value: 'retailer',
			// 			label: this.$t('erp.b2c.ordertype_normally', { defaultValue: '正常销售' })
			// 		},
			// 		{
			// 			value: 'dropship',
			// 			label: this.$t('erp.channelbase.part_sale_channel', { defaultValue: '分销渠道' })
			// 		},
			// 	],
			// 	formItem:{
			// 		labelWidth:this.styWidth,
			// 		tip: this.showtipcreate && this.formData.saleType=='retailer' ? '' : `<div class="color-error">${this.$t('erp.channelbase.system_order_tip', { defaultValue: '分销渠道:系统订单会根据渠道对应关系自动的把价格更新为分销的价格' })}</div>`,
			// 		style:"margin-bottom:30px"
			// 	}
			// },

			// query3
			{
				label: this.$t('erp.channelbase.order_tip', { defaultValue: "订单是否默认为展示订单" }),
				required: false,
				show:this.query,
				valueText:this.formData.orderOnlyShow=='Y'? this.$t('erp.global.yes', { defaultValue: '是' }): this.$t('erp.global.no', { defaultValue: '否' }),
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			{
				label: this.$t('erp.channelbase.order_tip', { defaultValue: "订单是否默认为展示订单" }),
				key: "orderOnlyShow",
				tag:"div",
				required: false,
				show:!this.query,
				// valueText: this.formData.orderOnlyShow=='Y'? this.$t('erp.global.yes', { defaultValue: '是' }): this.$t('erp.global.no', { defaultValue: '否' }),
				// props: {
				// 	strict: false,
				// },
				// options: [{
				// 	trueValue: 'Y',
				// 	label: this.$t('erp.global.yes', { defaultValue: '是' })
				// }, {
				// 	trueValue: 'N',
				// 	label: this.$t('erp.global.no', { defaultValue: '否' })
				// }],
				formItem:{
					labelWidth:this.styWidth,
                    // tip: this.showtip ? '' : `<div class="color-error">${this.$t('erp.channelbase.isordershow', { defaultValue: '订单是否默认为展示订单' })}</div>`,
					// style:"margin-bottom:30px",
				},
                children:()=>{
                    return <div>
                        <div><Tooltip  max-width="300"  content={this.$t('erp.channelbase.isordershow', { defaultValue: '订单是否默认为展示订单' })} placement="top"> <Icon class="font-14" type="md-help-circle" /> </Tooltip>
                                <RadioGroup v-model={this.formData.orderOnlyShow}>
                                    <Radio label="Y">
                                        <span class="font-12">{this.$t('erp.global.yes', { defaultValue: '是' })}</span>
                                    </Radio>
                                    <Radio label="N">
                                        <span class="font-12">{this.$t('erp.global.no', { defaultValue: '否' })}</span>
                                    </Radio>
                                </RadioGroup>
                        </div>
                    </div>
                }
			},
			// query4
			// {
			// 	label: "是否默认手动发货",
			// 	required: false,
			// 	show:this.query,
			// 	valueText:this.formData.defaultManMadeShipment==1?'是':'否',
			// 	formItem:{
			// 		labelWidth:this.styWidth,
			// 	}
			// },
			// {
			// 	label: "是否默认手动发货",
			// 	key: "defaultManMadeShipment",
			// 	tag:"vRadio",
			// 	required: false,
			// 	show:!this.query,
			// 	props: {
			// 		strict: false,
			// 	},
			// 	options: [{
			// 		trueValue: 1,
			// 		label: '是'
			// 	}, {
			// 		trueValue: 0,
			// 		label: '否'
			// 	}],
			// 	formItem:{
			// 		labelWidth:this.styWidth,
			// 		tip: this.showtipcreate && this.formData.defaultManMadeShipment=='0' ? '' : '<div class="color-error">该渠道的所有产品，会默认手动发货，也支持前往渠道产品管理中再对各seller sku的发货属性进行修改</div>',
			// 		style:"margin-bottom:30px"
			// 	}
			// },
			// query5
			{
				label: this.$t('erp.channelbase.not_connect_order', { defaultValue: "未关联项目的订单是否默认为展示单" }),
				required: false,
				show:this.query,
				valueText:this.formData.isLineRelate=='Y'?this.$t('erp.global.yes', { defaultValue: '是' }):this.$t('erp.global.no', { defaultValue: '否' }),
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			{
				label: this.$t('erp.channelbase.not_connect_order', { defaultValue: "未关联项目的订单是否默认为展示单" }),
				key: "isLineRelate",
				tag:"div",
				show:!this.query,
				required: false,
				// valueText: this.formData.isLineRelate=='Y'?this.$t('erp.global.yes', { defaultValue: '是' }):this.$t('erp.global.no', { defaultValue: '否' }),
				// props: {
				// 	strict: false,
				// },
				// options: [{
				// 	trueValue: 'Y',
				// 	label: this.$t('erp.global.yes', { defaultValue: '是' })
				// }, {
				// 	trueValue: 'N',
				// 	label: this.$t('erp.global.no', { defaultValue: '否' })
				// }],
				formItem:{
					labelWidth:this.styWidth,
                    // tip: this.showtip ? '' : `<div class="color-error">${this.$t('erp.channelbase.isLineRelate', { defaultValue: '未关联项目的订单是否默认为展示单' })}</div>`,
				},
                children:()=>{
                    return <div>
                        <div><Tooltip  max-width="300"  content={this.$t('erp.channelbase.isLineRelate', { defaultValue: '未关联项目的订单是否默认为展示单' })} placement="top"> <Icon class="font-14" type="md-help-circle" /> </Tooltip>
                                <RadioGroup v-model={this.formData.isLineRelate}>
                                    <Radio label="Y">
                                        <span class="font-12">{this.$t('erp.global.yes', { defaultValue: '是' })}</span>
                                    </Radio>
                                    <Radio label="N">
                                        <span class="font-12">{this.$t('erp.global.no', { defaultValue: '否' })}</span>
                                    </Radio>
                                </RadioGroup>
                        </div>
                    </div>
                }
			},
			// query6
			// {
			// 	label: this.$t('erp.channelbase.not_connection_project', { defaultValue: "未关联项目的订单默认关联项目" }),
			// 	tag: 'vSelect',
			// 	key: "lineRelateId",
			// 	required: false,
			// 	show:this.query,
			// 	valueText: (
			// 		this.productList.find(item => {
			// 			return (
			// 				this.formData.lineRelateId == item.value
			// 			);
			// 		}) || {}
			// 	).label,
			// 	formItem:{
			// 		labelWidth:this.styWidth,
			// 	}
			// },
			// {
			// 	label: this.$t('erp.channelbase.not_connection_project', { defaultValue: "未关联项目的订单默认关联项目" }),
			// 	tag: 'vSelect',
			// 	key: "lineRelateId",
			// 	show:!this.query,
			// 	required: false,
			// 	options:this.productList,
			// 	formItem:{
			// 		labelWidth:this.styWidth,
            //         tip: this.showtip ? '' : `<div class="color-error">${this.$t('erp.channelbase.lineRelateId', { defaultValue: '未关联项目的订单默认关联项目' })}</div>`,
			// 	},
			// 	props:{
			// 		filterable:true,
			// 	}

			// },
			// query7
			{
				label: this.$t('erp.channelbase.is_channel_pay_cost', { defaultValue: "是否渠道支付运费" }),
				required: false,
				show:this.query,
				valueText:this.formData.isAccountPay==1?this.$t('erp.global.yes', { defaultValue: '是' }):this.$t('erp.global.no', { defaultValue: '否' }),
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			{
				label: this.$t('erp.channelbase.is_channel_pay_cost', { defaultValue: "是否渠道支付运费" }),
				key: "isAccountPay",
				tag:"div",
				show:!this.query,
				required: false,
				// valueText: this.formData.isAccountPay==1?this.$t('erp.global.yes', { defaultValue: '是' }):this.$t('erp.global.no', { defaultValue: '否' }),
				// props: {
				// 	strict: false,
				// },
				// options: [{
				// 	trueValue: 1,
				// 	label: this.$t('erp.global.yes', { defaultValue: '是' })
				// }, {
				// 	trueValue: 0,
				// 	label: this.$t('erp.global.no', { defaultValue: '否' }),
                // }],
                on:{
                    'on-change':(val)=>{
                        // console.log(val)
                        this.formData.issueAccountPay = val
                    }
                },
				formItem:{
					labelWidth:this.styWidth,
                    // tip: this.showtip ? '' : `<div class="color-error">${this.$t('erp.channelbase.isAccountPay', { defaultValue: '是否渠道支付运费' })}</div>`,
				},
                children:()=>{
                    return <div>
                        <div><Tooltip  max-width="300"  content={this.$t('erp.channelbase.isAccountPay', { defaultValue: '是否渠道支付运费' })} placement="top"> <Icon class="font-14" type="md-help-circle" /> </Tooltip>
                                <RadioGroup v-model={this.formData.isAccountPay}>
                                    <Radio label="1">
                                        <span class="font-12">{this.$t('erp.global.yes', { defaultValue: '是' })}</span>
                                    </Radio>
                                    <Radio label="0">
                                        <span class="font-12">{this.$t('erp.global.no', { defaultValue: '否' })}</span>
                                    </Radio>
                                </RadioGroup>
                        </div>
                    </div>
                }
			},

            // query8
			{
				label: this.$t('erp.channelbase.bufa_is_channel_pay_cost', { defaultValue: "补发单是否渠道支付运费" }),
				required: false,
				show:this.query,
				valueText:this.formData.issueAccountPay==1?this.$t('erp.global.yes', { defaultValue: '是' }):this.$t('erp.global.no', { defaultValue: '否' }),
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			{
				label: this.$t('erp.channelbase.bufa_is_channel_pay_cost', { defaultValue: "补发单是否渠道支付运费" }),
				key: "issueAccountPay",
				tag:"div",
				required: false,
				show:!this.query,
				// valueText:this.formData.isOpenSFP=='1'?'是':'否',
				// props: {
				// 	strict: false,
				// },
				// options: [{
				// 	trueValue: 1,
				// 	label: this.$t('erp.global.yes', { defaultValue: '是' })
				// }, {
				// 	trueValue: 0,
				// 	label: this.$t('erp.global.no', { defaultValue: '否' })
				// }],
				formItem:{
					labelWidth:this.styWidth,
                    // tip: this.showtip ? '' : `<div class="color-error">${this.$t('erp.channelbase.issueAccountPay', { defaultValue: '补发单是否渠道支付运费' })}</div>`,
				},
                children:()=>{
                    return <div>
                        <div><Tooltip  max-width="300"  content={this.$t('erp.channelbase.issueAccountPay', { defaultValue: '补发单是否渠道支付运费' })} placement="top"> <Icon class="font-14" type="md-help-circle" /> </Tooltip>
                                <RadioGroup v-model={this.formData.issueAccountPay}>
                                    <Radio label="1">
                                        <span class="font-12">{this.$t('erp.global.yes', { defaultValue: '是' })}</span>
                                    </Radio>
                                    <Radio label="0">
                                        <span class="font-12">{this.$t('erp.global.no', { defaultValue: '否' })}</span>
                                    </Radio>
                                </RadioGroup>
                        </div>
                    </div>
                }
			},
			// query10
			{
				label: this.$t('erp.channelbase.is_allow_update_state', { defaultValue: "是否允许更新发货状态" }),
				required: false,
				show:this.query,
				valueText:this.formData.allowUpdate==1?this.$t('erp.global.yes', { defaultValue: '是' }):this.$t('erp.global.no', { defaultValue: '否' }),
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			{
				label: this.$t('erp.channelbase.is_allow_update_state', { defaultValue: "是否允许更新发货状态" }),
				key: "allowUpdate",
				tag:"div",
				required: false,
				show:!this.query,
				// props: {
				// 	strict: false,
				// },
				// options: [{
				// 	trueValue: 1,
				// 	label: this.$t('erp.global.yes', { defaultValue: '是' })
				// }, {
				// 	trueValue: 0,
				// 	label: this.$t('erp.global.no', { defaultValue: '否' })
				// }],
				formItem:{
					labelWidth:this.styWidth,
                    // tip: this.showtip ? '' : `<div class="color-error">${this.$t('erp.channelbase.allowUpdate', { defaultValue: '是否允许更新发货状态' })}</div>`,
				},
                children:()=>{
                    return <div>
                        <div><Tooltip  max-width="300"  content={this.$t('erp.channelbase.allowUpdate', { defaultValue: '是否允许更新发货状态' })} placement="top"> <Icon class="font-14" type="md-help-circle" /> </Tooltip>
                                <RadioGroup v-model={this.formData.allowUpdate}>
                                    <Radio label="1">
                                        <span class="font-12">{this.$t('erp.global.yes', { defaultValue: '是' })}</span>
                                    </Radio>
                                    <Radio label="0">
                                        <span class="font-12">{this.$t('erp.global.no', { defaultValue: '否' })}</span>
                                    </Radio>
                                </RadioGroup>
                        </div>
                    </div>
                }
			},
            // query2
			{
				label: this.$t('erp.channelbase.send_allow_max_days', { defaultValue: "发货允许最大天数" }),
				key: "timeoutDays",
				required: false,
				show:this.query,
				formItem:{
					labelWidth:this.styWidth,
				},
			},
			{
				label: this.$t('erp.channelbase.send_allow_max_days', { defaultValue: "发货允许最大天数" }),
				key: "timeoutDays",
				required: false,
				show:!this.query,
				formItem:{
					labelWidth:this.styWidth,
					// tip: this.showtip ? '' : `<div class="color-error">${this.$t('erp.channelbase.max_days_tip', { defaultValue: '超过最大天数订单会变为发货超时订单。若平台有发运允许最大天数，以平台为准' })}</div>`,
					// style:"margin-bottom:30px"
				},
                popper:this.$t('erp.channelbase.max_days_tip', { defaultValue: '超过最大天数订单会变为发货超时订单。若平台有发运允许最大天数，以平台为准' }),
			},
            // // query9
			{
				label: this.$t('erp.channelbase.carrier_upload_attach', { defaultValue: "哪些carrier需要上传附件" }),
				key: "bossShippingMethodCode",
				required: false,
				show:this.query,
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			{
				label: this.$t('erp.channelbase.carrier_upload_attach', { defaultValue: "哪些carrier需要上传附件" }),
				key: "bossShippingMethodCode",
				tag:'vSelect',
				required: false,
				show:!this.query,
				options:this.sysdeliveries,
				props:{
					filterable:true,
					multiple:true,
				},
				formItem:{
					labelWidth:this.styWidth,
                    // tip: this.showtip ? '' : `<div class="color-error">${this.$t('erp.channelbase.bossShippingMethodCode', { defaultValue: '哪些carrier需要上传附件' })}</div>`,
				},
            },

			];
		},
        getChannelInfo () {
            return [
                {
                    label: this.$t('global.common.name', { defaultValue: "名称" }),
                    key: "name",
                    tag: "vInput",
                    on: {
                        "on-change": this.handleRequire
                    },
                    required: this.requireChannelInfo,
                    // required: this.handleRequire,
                    formItem:{
                        labelWidth:this.styWidth,
                    }
                },
                {
                    label: this.$t('erp.b2border.addressone', { defaultValue: "地址1" }),
                    key: "address",
                    tag: "vInput",
                    on: {
                        "on-change": this.handleRequire
                    },
                    required: this.requireChannelInfo,
                    formItem:{
                        labelWidth:this.styWidth,
                    }
                },
                {
                    label: this.$t('erp.b2border.addresstwo', { defaultValue: "地址2" }),
                    key: "address2",
                    tag: "vInput",
                    required: false,
                    formItem:{
                        labelWidth:this.styWidth,
                    }
                },
                {
                    label: this.$t('erp.b2c.city', { defaultValue: "城市" }),
                    key: "city",
                    tag: "vInput",
                    on: {
                        "on-change": this.handleRequire
                    },
                    required: this.requireChannelInfo,
                    formItem:{
                        labelWidth:this.styWidth,
                    }
                },
                {
                    label: this.$t('erp.b2c.state_province', { defaultValue: "州" }),
                    key: "state",
                    tag: "vInput",
                    on: {
                        "on-change": this.handleRequire
                    },
                    required: this.requireChannelInfo,
                    formItem:{
                        labelWidth:this.styWidth,
                    }
                },
                {
                    label: this.$t('erp.channelbase.country', { defaultValue: "国家" }),
                    key: "country",
                    tag: "vInput",
                    on: {
                        "on-change": this.handleRequire
                    },
                    required: this.requireChannelInfo,
                    formItem:{
                        labelWidth:this.styWidth,
                    }
                },
                {
                    label: this.$t('erp.b2c.zip_code', { defaultValue: "邮编" }),
                    key: "postcode",
                    tag: "vInput",
                    on: {
                        "on-change": this.handleRequire
                    },
                    required: this.requireChannelInfo,
                    formItem:{
                        labelWidth:this.styWidth,
                    }
                }
            ]
        },
		getOther(){
			return [{
				label: this.$t('erp.channelbase.channel_currency', { defaultValue: "渠道币种" }),
				key: "currency",
				show:this.query,
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			{
				label: this.$t('erp.channelbase.vat_sale', { defaultValue: "VAT销售税税率" }),
				show:this.query,
				valueText:this.formData.vatRate +' %',
				formItem:{
					labelWidth:this.styWidth,
				}
			},
			{
				label: this.$t('erp.channelbase.account_incharge_phone', { defaultValue: "账号负责人电话" }),
				key: "manageUserTels",
				required:false,
				span:24,
				formItem:{
					labelWidth:this.styWidth,
					tip: this.showtip ? '' : `<div class="color-error">${this.$t('erp.channelbase.account_exception_tip', { defaultValue: '账号发生异常会自动提醒账号的负责人，请填写负责人手机号，若有多个可用逗号隔开' })}</div>`,
					style:"width:50%"
				},
				props:{
					placeholder: this.$t('erp.channelbase.input_phone_incharge', { defaultValue: '请填写负责人手机号，若有多个可用逗号隔开' }),
				}
			},
			{
				label: this.$t('erp.channelbase.auth_date', { defaultValue: "授权日期" }),
				tag: 'vDatepicker',
				key: 'authorizationAt',
				// query:this.type == 'query',
				required:false,
				props:{
					format:'yy-mm-dd',
					confirm:false,
					placeholder: this.$t('erp.channelbase.auth_date_tip', { defaultValue: '授权到期前15天，自动提醒账号负责人' }),
				},
				formItem:{
					labelWidth:this.styWidth,
				}
            },
            {
                label: this.$t("erp.channelbase.timezone", { defaultValue: "店铺时区" }),
                tag: "vSelect",
                key: "timeZone",
                required: false,
                options: this.timeZoneList,
                props: {
                    filterable: true,
                    disabled: this.type == 'edit' && !this.formData.timeZone
                },
				formItem:{
					labelWidth:this.styWidth,
				}
            },
			];
		},
    },
    methods:{
		...mapMutations('diction', ['clearStore']),
        getTimeZone () {
            HttpGetTimeZone().then(res => {
                if (!res.data) return;
                this.timeZoneList = Object.keys(res.data).map(key => {
                    return {
                        // label: `${key}(${res.data[key]})`,
                        label: key,
                        value: key
                    }
                });
            }, err => {
                this.$VMessage.error(err.message);
            });
        },
        handleSelectTimeZone (timeZone) {
            console.log('@on-timezone', timeZone);
            this.$set(this.formData, "timeZone", timeZone);
        },
        // 店铺注册信息必填逻辑
        handleRequire (value) {
            if (value) return this.$set(this, 'requireChannelInfo', true);
            if (!value) {
                let validResult = false;
                Object.keys(this.formData).map(key => {
                    this.validKey.map(item => {
                        if (key == item) {
                            if (this.formData[key]) {
                                validResult = true;
                            }
                        }
                    });
                });
                console.log(this.formData);
                console.log(validResult, this.validKey);
                this.$set(this, 'requireChannelInfo', validResult);
            }
        },
        // 渠道title获取
        getTypeTitle(flagtype){
            console.log(flagtype)
            let onetitle = this.allaccounties.filter(item=>{ return item.name.toLowerCase() === flagtype})[0];
            if(flagtype == 'amazonvendords'){
                onetitle.note = 'AmazonVendor'
            }
            return onetitle.note
        },
		dedupe(array) {
			var temp = []; //一个新的临时数组
			for(var i = 0; i < array.length; i++){
				if(temp.indexOf(array[i]) == -1){
					temp.push(array[i]);
				}
			}
			return temp;
		},
		getNowFormatDate(){
            let date = new Date();
            let seperator1 = "-";
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            let currentdate = year + seperator1 + month + seperator1 + strDate;
			this.nowdate =  currentdate;
			this.formData.beginSalesDate = currentdate
            // console.log(this.nowdate)
        },
        getDetail(){
			this.loading = true
			HttpQueryAccount({
				id:this.id
			}).then(res=>{
				this.handleResponse(res.data);
			},err=>{
				this.errorMessage(err.message);
			}).finally(res=>{
				this.loading = false;
			})
			HttpSysOpLog(this.LogformData).then(res=>{
                this.opLogList = res.data.content
            },err=>{
                this.errorMessage(err.message);
            })
		},
		handleResponse(data={}){
			this.formData = data
			this.formData.type == data.type.toLowerCase()

            this.formData.isAccountPay = this.formData.isAccountPay.toString();
            this.formData.issueAccountPay = this.formData.issueAccountPay.toString();
            this.formData.allowUpdate = this.formData.allowUpdate.toString();

            this.shopdatalist = data.list;

			// 把每个对应的值赋值一遍
            console.log(JSON.parse(data.connectStr))
			let connectStr = JSON.parse(data.connectStr)
			console.log(this.formData)
			this.queryFormData.countryCode = data.countryCode
			this.queryFormData.defaultAccount = data.areaCode
			// this.queryFormData.type = data.type.toLowerCase()
			// console.log(this.formData.type.toLowerCase())
			switch(this.formData.type.toLowerCase()){
				case 'amazon':
					// amazon
					if(this.type == 'query'){
						this.queryFormData.merchantToken = connectStr.merchantToken
						this.queryFormData.mwsAuthToken = connectStr.mwsAuthToken
						this.queryFormData.sellerId = connectStr.sellerId
						this.queryFormData.parentAccountFlag = this.formData.parentAccountFlag
					}else{
						this.queryFormData.merchantToken = this.queryFormData.mwsAuthToken = this.queryFormData.sellerId = ''
						this.queryFormData.parentAccountFlag = this.formData.parentAccountFlag
					}
				break
				case 'ebay':
					// ebay
					if(this.type == 'query'){
						this.queryFormData.ebayToken = connectStr.ebayToken
					}else{
						this.queryFormData.ebayToken = ''
					}
				break
				case 'walmart':
					// walmart
					if(this.type == 'query'){
						// this.queryFormData.consumerId = connectStr.consumerId
						// this.queryFormData.privateEncodedStr = connectStr.privateEncodedStr
						this.queryFormData.host = connectStr.host
						this.queryFormData.name = connectStr.name
						this.queryFormData.clientId = connectStr.clientId
						this.queryFormData.clientSecret = connectStr.clientSecret
						// this.queryFormData.type = connectStr.type
					}else{
						this.queryFormData.host = this.queryFormData.name = this.queryFormData.clientId = this.queryFormData.clientSecret = ''
					}
				break
				case 'walmart_dsv':
					if(this.type == 'query'){
						this.queryFormData.clientId = connectStr.clientId
						this.queryFormData.clientSecret = connectStr.clientSecret
						//this.queryFormData.correlationId = connectStr.correlationId
						//this.queryFormData.privateEncodedStr = connectStr.privateEncodedStr
						this.queryFormData.host = connectStr.host
						// this.queryFormData.shipNodeList = connectStr.shipNodeList
						//this.queryFormData.serviceName = connectStr.serviceName
						// this.queryFormData.type = connectStr.type
					}else{
						this.queryFormData.clientId = this.queryFormData.clientId = this.queryFormData.host = ''
					}
				break

                case 'amazonvendor':
					if(this.type == 'query'){
						this.queryFormData.po = connectStr.po
					}else{
					}
				break

                case 'amazonvendords':
					if(this.type == 'query'){
						this.queryFormData.dropship = connectStr.dropship
						this.queryFormData.sellingPartyId = connectStr.sellingPartyId
                        this.queryFormData.IsLabeled = connectStr.IsLabeled
					}else{
                        this.queryFormData.IsLabeled = connectStr.IsLabeled;
						this.queryFormData.sellingPartyId = ''
					}
                    break

				case 'wayfair':
					if(this.type == 'query'){
						this.queryFormData.clientId = connectStr.clientId
						this.queryFormData.clientSecret = connectStr.clientSecret
						this.queryFormData.sandboxClientSecret = connectStr.sandboxClientSecret
						this.queryFormData.sandboxClientId = connectStr.sandboxClientId
						// this.queryFormData.ftpHost = connectStr.ftpHost
						// this.queryFormData.ftpUsername = connectStr.ftpUsername
						// this.queryFormData.ftpPassword = connectStr.ftpPassword
						this.queryFormData.SPlabel = connectStr.SPlabel
						this.queryFormData.LTLlabel = connectStr.LTLlabel
						this.queryFormData.dryRun = connectStr.dryRun
						this.queryFormData.packingSlip = connectStr.packingSlip
					}else{
						// this.queryFormData.clientId = this.queryFormData.clientSecret = this.queryFormData.dryRun = this.queryFormData.packingSlip = this.queryFormData.sandboxClientSecret = this.queryFormData.sandboxClientId = this.queryFormData.SPlabel = this.queryFormData.LTLlabel =''
					}
				break

                case 'yamibuy':
					if(this.type == 'query'){
						this.queryFormData.app_key = connectStr.app_key
						this.queryFormData.app_secret= connectStr.app_secret
					}else{
						this.queryFormData.app_key = this.queryFormData.app_secret= ''
					}
                    break


				case 'overstock':
					if(this.type == 'query'){
						this.queryFormData.username = connectStr.username
						this.queryFormData.password = connectStr.password
						this.queryFormData.domain = connectStr.domain
					}else{
						this.queryFormData.username = this.queryFormData.password = this.queryFormData.domain = ''
					}
				break

				case 'allexpress':
					if(this.type == 'query'){
						this.queryFormData.aliClientId = connectStr.aliClientId
						this.queryFormData.aliAppsecret = connectStr.aliAppsecret
						this.queryFormData.aliRefreshtoken = connectStr.aliRefreshtoken
					}else{
						this.queryFormData.aliClientId = this.queryFormData.aliAppsecret = this.queryFormData.aliRefreshtoken = ''
					}
				break

				case 'houzz':
					if(this.type == 'query'){
						this.queryFormData.houzzUsername = connectStr.houzzUsername
						this.queryFormData.houzzToken = connectStr.houzzToken
						this.queryFormData.appname = connectStr.appname
					}else{
						this.queryFormData.houzzUsername = this.queryFormData.houzzToken = this.queryFormData.appname = ''
					}
				break

				case 'newegg':
					if(this.type == 'query'){
						this.queryFormData.neweggSellerId = connectStr.neweggSellerId
						this.queryFormData.neweggSecretKey = connectStr.neweggSecretKey
						this.queryFormData.neweggAuthorization = connectStr.neweggAuthorization
					}else{
						this.queryFormData.neweggSellerId = this.queryFormData.neweggSecretKey = this.queryFormData.neweggAuthorization = ''
					}
				break

				case 'pricefalls':
					if(this.type == 'query'){
						this.queryFormData.ftp_adrr = connectStr.ftp_adrr
						this.queryFormData.ftp_port = connectStr.ftp_port
						this.queryFormData.ftp_user = connectStr.ftp_user
						this.queryFormData.ftp_pass = connectStr.ftp_pass
					}else{
						this.queryFormData.ftp_adrr = this.queryFormData.ftp_port = this.queryFormData.ftp_user = this.queryFormData.ftp_pass = ''
					}
				break

				case 'shopify':
					if(this.type == 'query'){
						this.queryFormData.apiKey = connectStr.apiKey
						this.queryFormData.password = connectStr.password
						this.queryFormData.hostname = connectStr.hostname
					}else{
						this.queryFormData.apiKey = this.queryFormData.password = this.queryFormData.hostname = ''
					}
				break
				case 'homedepot': case 'lowes':
					if(this.type == 'query'){
						this.queryFormData.ftpHost = connectStr.ftpHost
						this.queryFormData.ftpUsername = connectStr.ftpUsername
						this.queryFormData.ftpPassword = connectStr.ftpPassword
						this.queryFormData.port = connectStr.port
						this.queryFormData.paymentId = connectStr.paymentId
					}else{
						this.queryFormData.ftpHost = this.queryFormData.ftpUsername = this.queryFormData.ftpPassword = this.queryFormData.port = this.queryFormData.paymentId = ''
					}
				break
				case 'hayneedle':
					if(this.type == 'query'){
						this.queryFormData.ftpHost = connectStr.ftpHost
						this.queryFormData.ftpUsername = connectStr.ftpUsername
						this.queryFormData.ftpPassword = connectStr.ftpPassword
						this.queryFormData.ftpAccount = connectStr.ftpAccount
						this.queryFormData.port = connectStr.port
						this.queryFormData.senderId = connectStr.senderId
						this.queryFormData.receiverId = connectStr.receiverId
					}else{
						this.queryFormData.ftpHost = this.queryFormData.ftpUsername = this.queryFormData.ftpPassword = this.queryFormData.ftpAccount = this.queryFormData.port = this.queryFormData.senderId = this.queryFormData.receiverId = ''
					}
				break
				case 'houzz_dsv':
					if(this.type == 'query'){
						this.queryFormData.appname = connectStr.appname
						this.queryFormData.houzzUsername = connectStr.houzzUsername
						this.queryFormData.houzzToken = connectStr.houzzToken
					}else{
						this.queryFormData.appname = this.queryFormData.houzzUsername = this.queryFormData.houzzToken = ''
					}
				break
				case 'sears':
					if(this.type == 'query'){
						this.queryFormData.searssellerId = connectStr.searssellerId
						this.queryFormData.emailAdrr = connectStr.emailAdrr
						this.queryFormData.searsToken = connectStr.searsToken
						// this.queryFormData.flag = connectStr.flag
					}else{
						this.queryFormData.searssellerId = this.queryFormData.emailAdrr = this.queryFormData.searsToken = ''
					}
				break
				case 'manomano':
					if(this.type == 'query'){
						this.queryFormData.username = connectStr.username
						this.queryFormData.password = connectStr.password
					}else{
						this.queryFormData.username = this.queryFormData.password = ''
					}
                break;
                case 'eccang':
					if(this.type == 'query'){
						this.queryFormData.username = connectStr.username
						this.queryFormData.userpass = connectStr.userpass
						this.queryFormData.servicetoken = connectStr.servicetoken
						this.queryFormData.apiurl1 = connectStr.apiurl1
                        this.queryFormData.apiurl2 = connectStr.apiurl2
                        this.queryFormData.ecWarehouses = connectStr.ecWarehouses
					}else{
						this.queryFormData.username = this.queryFormData.userpass = this.queryFormData.servicetoken = this.queryFormData.apiurl1 = this.queryFormData.apiurl2 = this.queryFormData.ecWarehouses = ''
					}
                break
                case 'costco':
					if(this.type == 'query'){
						this.queryFormData.ftpHost = connectStr.ftpHost
						this.queryFormData.ftpUsername = connectStr.ftpUsername
						this.queryFormData.ftpPassword = connectStr.ftpPassword
						this.queryFormData.port = connectStr.port
                        this.queryFormData.paymentId = connectStr.paymentId
                        this.queryFormData.sellerParty = connectStr.sellerParty
                        this.queryFormData.channelParty = connectStr.channelParty
                        this.queryFormData.orderPath = connectStr.orderPath
                        this.queryFormData.order997Path = connectStr.order997Path
                        this.queryFormData.orderConfirmPath = connectStr.orderConfirmPath
                        this.queryFormData.trackingPath = connectStr.trackingPath
                        this.queryFormData.inventoryPath = connectStr.inventoryPath
                        this.queryFormData.paymentPath = connectStr.paymentPath
                        this.queryFormData.shippingFilePath = connectStr.shippingFilePath
                        this.queryFormData.invoicePath = connectStr.invoicePath
					}else{
						this.queryFormData.ftpHost = this.queryFormData.ftpUsername = this.queryFormData.ftpPassword = this.queryFormData.port = this.queryFormData.paymentId = this.queryFormData.sellerParty = this.queryFormData.channelParty = this.queryFormData.orderPath = this.queryFormData.order997Path = this.queryFormData.orderConfirmPath = this.queryFormData.trackingPath = this.queryFormData.inventoryPath = this.queryFormData.paymentPath = this.queryFormData.shippingFilePath = this.queryFormData.invoicePath = ''
					}
                break
                case 'shipstation':
					if(this.type == 'query'){
						this.queryFormData.apiKey = connectStr.apiKey
						this.queryFormData.apiSecret = connectStr.apiSecret
					}else{
						this.queryFormData.apiKey = this.queryFormData.apiSecret = ''
					}
				break
			}
			let new_array = []
			for(let i in connectStr.new_flag){

				if(connectStr.new_flag[i]=='Y'){
					new_array.push(i)
				}
			}
			// console.log(new_array)
			this.queryFormData.new_flag = new_array
            if(this.formData.type.toLowerCase() == 'wayfair'){
                this.queryFormData.oldnew_flag = connectStr.new_flag
            }
			this.queryFormData = {...this.queryFormData}
			// console.log(this.queryFormData)
		},
		async submit(venflag){
            // console.log(this.$refs.createinterface,'createinterfacecreateinterface');
			// let errorwarn = false;
            // return
			const valid = await this.$refs['baseform'].validate();
			if (!valid) return;
            if (this.requireChannelInfo) {
                let validChannel = true;
                let validCount = [];
                Object.keys(this.formData).map(key => {
                    this.validKey.map(item => {
                        if (key == item) {
                            console.log(key, this.formData[key]);
                            validCount.push(true);
                            if (!this.formData[key]) return validChannel = false;
                        }
                    });
                });
                if (validCount.length != this.validKey.length) validChannel = false;
                if (!validChannel) return this.$VMessage.warning(this.$t('global.common.fill_required'));
            }
			if(this.type=='create'){
                let bool1 = await this.$refs.createinterface.validate();
                if (!bool1) return;
			}else{
                let bool2 = await this.$refs.queryinterface.validate();
				if (!bool2) return;
			}

			let array = [],countries = [],obj = {
				"product":"N",
				"order":"N",
                "report":"N",
                "finance":"N",
                "inbound":"N",
                "outbound":"N",
				"stock":"N"
			}, amazonObj = {
				"product":"N",
				"order":"N",
                "report":"N",
                "finance":"N",
                "inbound":"N",
                "outbound":"N",
				"stock":"N",
				"afnorder": "N"
			};

            this.formData.orgId = global.SYSID
			this.formData.flag = this.formData.title

			// 创建的时候，各个渠道传值的数据格式
			if(this.type=='create'){
				switch(this.formData.type){
					case 'amazon':
						 let ismain;
						//  console.log(this.$refs.createinterface.formData)
						// 亚马逊的提交数据类型
						this.$refs.createinterface.formData.areaCode.map((item)=>{
							countries = []
							let alist = this.$refs.createinterface.getCountryList(item)
							let checkismain = alist[this.$refs.createinterface.formData1[item].isMain]
							// console.log(checkismain)
							if(checkismain==undefined){
								this.$VMessage.error(this.$t('erp.channelbase.please_choose_default_main_account', { defaultValue: '请勾选默认主账号' }));
							}
							this.$refs.createinterface.formData1[item].countryCode.map((country,index)=>{
								this.$refs.createinterface.formData1[item].isProduct.map((json)=>{
									amazonObj[json] = 'Y'
								})
								// console.log(country)
								let data = {
									countryCode:country,
                                    sellerId:this.$refs.createinterface.formData1[item].sellerId,
									isMain: checkismain.value == country ? '1' : '0',
									connectStr:{
										new_flag: amazonObj,
										merchantToken:this.$refs.createinterface.formData1[item].merchantToken,
										mwsAuthToken:this.$refs.createinterface.formData1[item].mwsAuthToken,
										sellerId:this.$refs.createinterface.formData1[item].sellerId,
										marketplaceId:this.getMarketplaceId[country]
									}
								}
								data.connectStr = JSON.stringify(data.connectStr)
								countries.push(data)
							})
							let data1 = {
								areaCode : this.countryList[item].areaCode,
								countryRequest:countries
							}
							array.push(data1)
						})
					break;
                    case 'wayfair':
                        let wayfairFlag = {...this.$refs.createinterface.otherFormData}
                        // console.log(wayfairFlag,'wayfairFlag')
                        wayfairFlag.new_flag = wayfairFlag.wayfairnew_flag;
                        delete wayfairFlag.wayfairnew_flag;
                        if(wayfairFlag.new_flag.order == 'T' || wayfairFlag.new_flag.outbound == 'T' || wayfairFlag.new_flag.stock == 'T' || wayfairFlag.new_flag.product == 'T'){
                            if(!wayfairFlag.sandboxClientId || !wayfairFlag.sandboxClientSecret){
                                this.$VMessage.error('数据类型中选择测试环境，必须填写Sandbox Client Id和Sandbox Client Secret！');
                                return;
                            }
                        }
                        let dataone = {
							countryCode:'US',
							connectStr:JSON.stringify(wayfairFlag)
						}
                        array.push(dataone)
                    break;
                    case 'amazonvendor': case 'amazonvendords':
                        let vendorFlag = {...this.$refs.createinterface.vendorsData}
                        console.log(vendorFlag,'vendorFlagvendorFlag')
						if(vendorFlag.new_flag1.length>0){
							vendorFlag.new_flag1.map((json)=>{
									obj[json] = 'Y'
							})
							vendorFlag.new_flag1 = obj
						}else{
							vendorFlag.new_flag1 = obj
						}
                        if(vendorFlag.new_flag2.length>0){
							vendorFlag.new_flag2.map((json)=>{
									obj[json] = 'Y'
							})
							vendorFlag.new_flag2 = obj
						}else{
							vendorFlag.new_flag2 = obj
						}
                        if(vendorFlag.dropship == true){
                            this.formData.type = 'amazonvendords'
                            let vendordata1 = {
                                ...this.formData,
                                channelCategoryId:0,
                                countryRequest:[{
                                    countryCode:vendorFlag.countryCode,
                                    connectStr:JSON.stringify({
                                        countryCode:vendorFlag.countryCode,
                                        dropship:vendorFlag.dropship,
                                        sellingPartyId:vendorFlag.sellingPartyId,
                                        IsLabeled:vendorFlag.IsLabeled,
                                        new_flag:vendorFlag.new_flag1
                                    })
                                }],
                            }
                            // console.log(vendordata1,'datadata',copynewFlag)
                            array.push(vendordata1)
                        }
                        if(vendorFlag.po == true){
                            this.formData.type = 'amazonvendor'
                            let vendordata2 = {
                                ...this.formData,
                                channelCategoryId:0,
                                countryRequest:[{
                                    countryCode:vendorFlag.countryCode,
                                    connectStr:JSON.stringify({
                                        countryCode:vendorFlag.countryCode,
                                        po:vendorFlag.po,
                                        new_flag:vendorFlag.new_flag2
                                    })
                                }],
                            }
                            // console.log(vendordata2,'datadata',copynewFlag)
                            array.push(vendordata2)
                        }
                    break;
					default:
                        let copynewFlag = {...this.$refs.createinterface.otherFormData}
                        delete copynewFlag.wayfairnew_flag
						// 除了亚马逊的提交类型
						if(copynewFlag.new_flag.length>0){
							copynewFlag.new_flag.map((json)=>{
									obj[json] = 'Y'
							})
							copynewFlag.new_flag = obj
						}else{
							copynewFlag.new_flag = obj
						}
						let data = {
							countryCode:'US',
							connectStr:JSON.stringify(copynewFlag)
						}
                        // console.log(data,'datadata',copynewFlag)
						array.push(data)
					break;

				}
			}
			// 编辑的时候，各个渠道需要的传值数据格式
			if(this.type=='edit'){
				let editdata = {}
                // console.log(this.$refs.queryinterface.formData)
				this.$refs.queryinterface.formData.new_flag.map((json)=>{
					obj[json] = 'Y'
				})
				//在编辑的时候传的参数
				switch(this.formData.type){
					case 'amazon':
						// amazon
						this.$refs.queryinterface.formData.new_flag.map((json)=>{
							amazonObj[json] = 'Y'
						})
						editdata = {
							merchantToken:this.$refs.queryinterface.formData.merchantToken,
							mwsAuthToken:this.$refs.queryinterface.formData.mwsAuthToken,
							sellerId:this.$refs.queryinterface.formData.sellerId,
							marketplaceId:this.getMarketplaceId[this.formData.countryCode]
						}
					break
					case 'ebay':
						// ebay
						editdata = {
							ebayToken :this.$refs.queryinterface.formData.ebayToken,
						}
					break
					case 'walmart':
						// walmart
						editdata = {
							// consumerId: this.$refs.queryinterface.formData.consumerId,
							// privateEncodedStr: this.$refs.queryinterface.formData.privateEncodedStr,
							host: this.$refs.queryinterface.formData.host,
							name: this.$refs.queryinterface.formData.name,
							clientId: this.$refs.queryinterface.formData.clientId,
							clientSecret: this.$refs.queryinterface.formData.clientSecret,
							// type: this.$refs.queryinterface.formData.type,
						}
					break
					case 'walmart_dsv':
						editdata = {
                            clientId: this.$refs.queryinterface.formData.clientId,
                            clientSecret: this.$refs.queryinterface.formData.clientSecret,
							//correlationId: this.$refs.queryinterface.formData.correlationId,
							//privateEncodedStr: this.$refs.queryinterface.formData.privateEncodedStr,
							host: this.$refs.queryinterface.formData.host,
							// shipNodeList: this.$refs.queryinterface.formData.shipNodeList,
							//serviceName: this.$refs.queryinterface.formData.serviceName,
							// type: this.$refs.queryinterface.formData.type,
						}
					break

                    case 'amazonvendor':
                        editdata = {
                            po: this.$refs.queryinterface.formData.po,
                            ISAID: this.$refs.queryinterface.formData.ISAID,
                        }
					break

                    case 'amazonvendords':
                        editdata = {
                            sellingPartyId: this.$refs.queryinterface.formData.sellingPartyId,
                            dropship: this.$refs.queryinterface.formData.dropship,
                            ISAID: this.$refs.queryinterface.formData.ISAID,
                            IsLabeled:this.$refs.queryinterface.formData.IsLabeled,
                        }
                        break

					case 'wayfair':
						editdata = {
                            clientId:this.$refs.queryinterface.formData.clientId,
							clientSecret:this.$refs.queryinterface.formData.clientSecret,
							dryRun: this.$refs.queryinterface.formData.dryRun,
							packingSlip: this.$refs.queryinterface.formData.packingSlip,
							sandboxClientSecret:this.$refs.queryinterface.formData.sandboxClientSecret,
							sandboxClientId:this.$refs.queryinterface.formData.sandboxClientId,
							SPlabel:this.$refs.queryinterface.formData.SPlabel,
							LTLlabel:this.$refs.queryinterface.formData.LTLlabel,
							// ftpPassword:this.$refs.queryinterface.formData.ftpPassword,
							// port:this.$refs.queryinterface.formData.port,
							// qualifier:this.$refs.queryinterface.formData.qualifier,
						}
					break

                    case 'yamibuy':
                        editdata = {
                            app_key:this.$refs.queryinterface.formData.app_key,
                            app_secret:this.$refs.queryinterface.formData.app_secret,
                        }
                        break


					case 'overstock':
						editdata = {
							username:this.$refs.queryinterface.formData.username,
							password:this.$refs.queryinterface.formData.password,
							domain:this.$refs.queryinterface.formData.domain,
						}
					break

					case 'allexpress':
						editdata = {
							aliClientId:this.$refs.queryinterface.formData.aliClientId,
							aliAppsecret:this.$refs.queryinterface.formData.aliAppsecret,
							aliRefreshtoken:this.$refs.queryinterface.formData.aliRefreshtoken,
						}
					break

					case 'houzz':
						editdata = {
                            houzzUsername:this.$refs.queryinterface.formData.houzzUsername,
                            houzzToken:this.$refs.queryinterface.formData.houzzToken,
                            appname:this.$refs.queryinterface.formData.appname,
						}
					break

					case 'newegg':
						editdata = {
							neweggSellerId:this.$refs.queryinterface.formData.neweggSellerId,
							neweggSecretKey:this.$refs.queryinterface.formData.neweggSecretKey,
							neweggAuthorization:this.$refs.queryinterface.formData.neweggAuthorization,
						}
					break

					case 'pricefalls':
						editdata = {
							ftp_adrr:this.$refs.queryinterface.formData.ftp_adrr,
							ftp_port:this.$refs.queryinterface.formData.ftp_port,
							ftp_user:this.$refs.queryinterface.formData.ftp_user,
							ftp_pass:this.$refs.queryinterface.formData.ftp_pass,
						}
					break

					case 'shopify':
						editdata = {
							apiKey:this.$refs.queryinterface.formData.apiKey,
							password:this.$refs.queryinterface.formData.password,
							hostname:this.$refs.queryinterface.formData.hostname,
						}
					break
					case 'homedepot': case 'lowes':
						editdata = {
							ftpHost : this.$refs.queryinterface.formData.ftpHost,
							ftpUsername : this.$refs.queryinterface.formData.ftpUsername,
							ftpPassword : this.$refs.queryinterface.formData.ftpPassword,
							port : this.$refs.queryinterface.formData.port,
							paymentId : this.$refs.queryinterface.formData.paymentId
						}
					break
					case 'hayneedle':
						editdata = {
							ftpHost : this.$refs.queryinterface.formData.ftpHost,
							ftpUsername : this.$refs.queryinterface.formData.ftpUsername,
							ftpPassword : this.$refs.queryinterface.formData.ftpPassword,
							ftpAccount : this.$refs.queryinterface.formData.ftpAccount,
							port : this.$refs.queryinterface.formData.port,
							senderId : this.$refs.queryinterface.formData.senderId,
							receiverId : this.$refs.queryinterface.formData.receiverId,
						}
					break
					case 'houzz_dsv':
						editdata = {
							appname : this.$refs.queryinterface.formData.appname,
							houzzUsername : this.$refs.queryinterface.formData.houzzUsername,
							houzzToken : this.$refs.queryinterface.formData.houzzToken,
						}
					break
					case 'sears':
						editdata = {
							searssellerId : this.$refs.queryinterface.formData.searssellerId,
							emailAdrr : this.$refs.queryinterface.formData.emailAdrr,
							searsToken : this.$refs.queryinterface.formData.searsToken,
							flag : this.$refs.queryinterface.formData.flag,
						}
					break
					case 'manomano':
						editdata = {
							username: this.$refs.queryinterface.formData.username,
							password: this.$refs.queryinterface.formData.password,
						}
					break
                    case 'shipstation':
						editdata = {
							apiKey: this.$refs.queryinterface.formData.apiKey,
							apiSecret: this.$refs.queryinterface.formData.apiSecret,
						}
					break
				}
				editdata['new_flag'] = obj

				if(this.formData.type=='amazon'){
					// console.log(this.$refs.queryinterface.formData.parentAccountFlag)
					editdata['new_flag'] = amazonObj
					let data = {
						countryCode:this.formData.countryCode,
                        sellerId:editdata.sellerId,
						isMain:this.$refs.queryinterface.formData.parentAccountFlag == true ? 1 : 0,
						connectStr:editdata
					}
					data.connectStr = JSON.stringify(data.connectStr)
					countries.push(data)
					let data1 = {
						areaCode : this.formData.areaCode,
						countryRequest:countries
					}
					array.push(data1)
				}else if(this.formData.type=='wayfair'){
                    let wayfairFlag = {...this.$refs.queryinterface.formData}
                        // console.log(wayfairFlag,'wayfairFlag')
                        wayfairFlag.new_flag = wayfairFlag.oldnew_flag;
                        delete wayfairFlag.oldnew_flag;

                        let dataone = {
							countryCode:'US',
							connectStr:JSON.stringify(wayfairFlag)
						}
                        array.push(dataone)
                }else{
                    let copynewFlag = {...this.$refs.queryinterface.formData}
					if(copynewFlag.new_flag.length>0){
						copynewFlag.new_flag.map((json)=>{
								obj[json] = 'Y'
						})
						copynewFlag.new_flag = obj
					}else{
						copynewFlag.new_flag = obj
					}
					// console.log(copynewFlag)
					let data = {
						countryCode:this.formData.countryCode,
						connectStr:JSON.stringify(copynewFlag)
					}
					array.push(data)
				}
			}
			// 选取渠道类型时的渠道id
			let channelCategoryId;
			this.allaccounties.filter(item=>{
				// console.log(item)
				if(this.formData.type.toLowerCase() == item.name.toLowerCase()){
					channelCategoryId = item.id
				}
			})
            // 创建的时候，需要的添加的传值
			// console.log(channelCategoryId)
			this.formData.channelCategoryId = channelCategoryId

			// 匹配渠道名称
			if(this.type=='create'){
				var titleReg = /^[A-Za-z0-9-_]+$/;
				if(titleReg.test(this.formData.title)===false){
					this.$VMessage.error(this.$t('erp.channelbase.channel_name_warning', { defaultValue: '渠道名称输入不符合规范' }));
					return
				}
			}

            // 判断渠道为eccang单独的逻辑
            if(this.formData.type === 'eccang' && this.type=='create'){
                const connectStracc = JSON.parse(array[0].connectStr);
                if(connectStracc.new_flag.stock === 'Y'){
                    if(!connectStracc.apiurl2){
                        this.$VMessage.error('请填写ApiUrl2的值');
                        return;
                    }
                }
            }

            // console.log(array,'arrayarray')
			this.loading = true
			// 创建的时候走的提交逻辑
			if(this.type=='create'){
				if(this.formData.type=='amazon'){
					HttpSaveAccount({
                        request:{
                            ...this.formData,
						    areaCountryRequest:array,
                        },
                        list:[],

					}).then(res=>{
						this.$VMessage.success(res.message);
						this.$router.push({ name: "channelBase" })
					},err=>{
						this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
					}).finally(res=>{
						this.loading = false
					})
				}else if(this.formData.type=='amazonvendor' || this.formData.type=='amazonvendords'){
                    HttpSaveAccount({
                        list:array,
					}).then(res=>{
                        if(venflag == 'vendors'){
                            this.submitAuthor(res.message)
                        }
						this.$VMessage.success(this.$t('erp.managewarehouse.operate_success', { defaultValue: '操作成功' }));
						this.$router.push({ name: "channelBase" })
					},err=>{
						this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true
                        });
					}).finally(res=>{
						this.loading = false
					})
                }else if(this.formData.type!='amazon'){
					HttpSaveAccount({
                        request:{
                            ...this.formData,
                            countryRequest:array,
                            areaCountryRequest:[],
                        },
                        list:[],
					}).then(res=>{
						this.$VMessage.success(this.$t('erp.managewarehouse.operate_success', { defaultValue: '操作成功' }));
						this.$router.push({ name: "channelBase" })
					},err=>{
						this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true
                        });
					}).finally(res=>{
						this.loading = false
					})
				}
			}
			// 编辑走的提交逻辑
			else{
				let editFormdata = {
					orgId : global.SYSID,
                    id : this.id,
                    type : this.formData.type,
                    title : this.formData.title,
					channelCategoryId : this.formData.channelCategoryId,
					remark:this.formData.remark,
					saleType:this.formData.saleType,
					timeoutDays:this.formData.timeoutDays,
					orderOnlyShow:this.formData.orderOnlyShow,
					defaultManMadeShipment:this.formData.defaultManMadeShipment,
					isLineRelate:this.formData.isLineRelate,
					lineRelateId:this.formData.lineRelateId,
                    isAccountPay:this.formData.isAccountPay,
                    issueAccountPay:this.formData.issueAccountPay,
					isOpenSFP:this.formData.isOpenSFP,
					bossShippingMethodCode:this.formData.bossShippingMethodCode,
					allowUpdate:this.formData.allowUpdate,
					manageUserTels:this.formData.manageUserTels,
					authorizationAt:this.formData.authorizationAt,
                    address: this.formData.address,
                    address2: this.formData.address2,
                    city: this.formData.city,
                    country: this.formData.country,
                    name: this.formData.name,
                    postcode: this.formData.postcode,
                    state: this.formData.state,
                    timeZone: this.formData.timeZone
				}

				if(this.formData.type=='amazon'){
					HttpSaveAccount({
                        request:{
                            ...editFormdata,
						    areaCountryRequest:array,
                        },
                        list:[],

					}).then(res=>{
						this.clearStore('newAccountList');
						this.$VMessage.success(this.$t('erp.managewarehouse.operate_success', { defaultValue: '操作成功' }));
						this.$router.push({ name: "channelBase" })
					},err=>{
						this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
					}).finally(res=>{
						this.loading = false
					})
				}else if(this.formData.type!='amazon'){
					HttpSaveAccount({
                        request:{
                            ...editFormdata,
                            countryRequest:array,
                            areaCountryRequest:[],
                        },
                        list:[],

					}).then(res=>{
						this.clearStore('newAccountList');
						this.$VMessage.success(this.$t('erp.managewarehouse.operate_success', { defaultValue: '操作成功' }));
                        if(venflag == 'vendors'){
                            this.submitAuthor(res.message)
                        }
						this.$router.push({ name: "channelBase" })
					},err=>{
						this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true
                });
					}).finally(res=>{
						this.loading = false
					})
				}
			}

		},
		cancel(){
			this.$router.push({ name: "channelBase" })
		},
        submitAuthor(titleflag){
            HttpGetAccountInterface({
                channelFlag: titleflag,type:this.formData.type
            }).then(res=>{
                if(res.message){
                    window.open(res.message, '_blank');
                }else{
                    this.$VMessage.error({
                        content:this.$t('erp.channelbase.accountinterface_tips', { defaultValue: '此平台暂不支持授权' }),
                        duration:10,
                        closeable:true,
                    })
                }
            },err=>{
                this.$VMessage.error({
                    content:err.message,
                    duration:10,
                    closeable:true,
                })
            })
        }
    }
}
</script>



